import CloseIcon from 'Component/CloseIcon';
import { ResetAttributes as SourceResetAttributes } from 'SourceComponent/ResetAttributes/ResetAttributes.component';

import './ResetAttributes.override.style';

/** @namespace AdvoxBasic/Component/ResetAttributes/Component/ResetAttributes */
export class ResetAttributes extends SourceResetAttributes {
    renderSelectedOption(selectedOption) {
        const { toggleCustomFilter } = this.props;
        const { attribute_code, attribute_label, value_string } = selectedOption;
        const onRemove = () => toggleCustomFilter(attribute_code, value_string);

        return (
            <button
                block="ResetAttributes"
                elem="AttributeValue"
                key={value_string}
                onKeyDown={onRemove}
                onClick={onRemove}
                aria-label={__('Close')}
            >
                <div block="ResetAttributes" elem="AttributeLabel">
                    {`${attribute_label}:`}
                </div>
                <div block="ResetAttributes" elem="AttributeText">
                    {selectedOption.label}
                </div>
                <span block="ResetAttributes" elem="CloseIcon">
                    <CloseIcon />
                </span>
            </button>
        );
    }

    renderResetItem(title, selectedOptions) {
        return (
            <div block="ResetAttributes" elem="Attribute" key={title}>
                {selectedOptions.map((o) => this.renderSelectedOption(o))}
            </div>
        );
    }

    render() {
        const { filtersData = {} } = this.props;

        if (!Object.keys(filtersData).length) {
            return null;
        }

        return (
            <>{Object.entries(filtersData).map(([attrName, attrData]) => this.renderResetItem(attrName, attrData))}</>
        );
    }
}

export default ResetAttributes;
